import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Connect, PropsFromRedux } from './MobileActionsContainer';
import { SearchDecisionWatcher } from '../search-watcher/SearchDecisionWatcher';
import { reportFilterToggle } from './filtersUtils';
import { SecondaryButton } from '../../../components/button';
import { SearchCommentaryWatcher } from '../search-watcher/SearchCommentaryWatcher';
import styles from './mobile_action.module.scss';
import { Column } from '../../../components/grid/Grid';

type Props = PropsFromRedux;

export const RawMobileActions: FC<Props> = ({
  displayed,
  hasFilters,
  selectedFiltersLength,
  totalHits,
  type,
  isSearchLoading,
  openFilter,
  query,
}) => {
  const handleOpenFilter = () => {
    reportFilterToggle(type, 'all_filters', true);
    openFilter();
  };

  if (!displayed) return null;

  return (
    <Column
      large={8}
      medium={12}
      className={styles.wrapper}
      data-test-id="mobile-actions"
    >
      {!isSearchLoading && totalHits > 0 && type === 'arret' && (
        <SearchDecisionWatcher />
      )}
      {!isSearchLoading && totalHits > 0 && type === 'commentary' && (
        <SearchCommentaryWatcher query={query} />
      )}
      {hasFilters && (
        <SecondaryButton onClick={handleOpenFilter} iconLeft="filter_list">
          <FormattedMessage id="search/components/mobile-actions/MobileActions.tsx/1" />
          {selectedFiltersLength > 0 && (
            <span>
              {'\u00A0'}
              <FormattedMessage
                id="search/components/mobile-actions/MobileActions.tsx/2"
                values={{ length: selectedFiltersLength }}
              />
            </span>
          )}
        </SecondaryButton>
      )}
    </Column>
  );
};

export const MobileActions = Connect(RawMobileActions);
